import { Dropdown, Menu } from "antd";
import React, { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { IoIosList } from "react-icons/io";
import FetchContext from "../../../../contexts/fetch";
import FlowContext from "../../../../contexts/flowContext";
import UserContext from "../../../../contexts/user";
import Spinner from "../../../Spinner";
import styles from "../controls.module.css";
import NewFlowForm from "./NewFlowForm";
import feedbacksTemplate from "../../../../utils/templates/webapp/feedbacksTemplate";
import Search from "./Search";

const FlowList = () => {
  const [fetchState, fetchDispatcher] = useContext(FetchContext);
  const [, flowDispatcher] = useContext(FlowContext);
  const [, userDispatcher] = useContext(UserContext);
  const [newFormVisible, setNewFormVisible] = useState(false);
  const [newElementName, setNewElementName] = useState("");
  const [newFlowBrand, setNewFlowBrand] = useState("");
  const [newFlowName, setNewFlowName] = useState("");

  const [filteredFlows, setFilteredFlows] = useState(fetchState.flows);
  const [focusedItem, setFocusedItem] = useState(null);

  const navigate = useNavigate();
  const params = useParams();

  const handleFlowSelectChange = function (item, key, keyPath, domEvent) {
    let selectedFlow = null;
    filteredFlows.forEach((brandFlows) => {
      Object.keys(brandFlows.transformed_flows).forEach((flowName) => {
        brandFlows.transformed_flows[flowName].forEach((flow) => {
          if (flow._id === item.keyPath[0].split("-")[2]) {
            selectedFlow = flow;
          }
        });
      });
    });

    let newFlow = null;

    if (selectedFlow) {
      fetchDispatcher({
        type: "fetch-flow-status",
        app: selectedFlow.app,
        brand: selectedFlow.brand,
        flowName: selectedFlow.name,
        flowId: selectedFlow._id,
      });

      flowDispatcher({
        type: "clear-flow",
      });

      newFlow = selectedFlow;
      flowDispatcher({
        type: "update-flow",
        flow: newFlow,
      });
      userDispatcher({
        type: "change-app",
        app: newFlow.app,
      });
      userDispatcher({
        type: "change-brand",
        brand: newFlow.brand,
      });
      userDispatcher({
        type: "change-flow-name",
        flowName: newFlow.name,
      });
      userDispatcher({
        type: "change-version",
        version: newFlow.version,
      });
    } else {
      setNewFormVisible(true);
      console.log("new ::", item);
      if (item.keyPath.length === 1) {
        // new brand
        setNewElementName("brand");
      } else if (item.keyPath.length === 2) {
        //new flow
        setNewFlowBrand(item.keyPath[1]);
        setNewElementName("name");
      } else if (item.keyPath.length === 3) {
        //new version
        let regex = new RegExp(item.keyPath[1], "g");

        setNewFlowBrand(item.keyPath[2]);
        setNewFlowName(item.keyPath[0].replace(regex, "").slice(0, -1));
        setNewElementName("version");
      }
    }
  };

  const getNew = function (element, key = 0) {
    let label = "";
    switch (element) {
      case "brand":
        label = "Nouvelle marque";
        break;
      case "flow":
        label = "Nouveau flux";
        break;
      case "version":
        label = "Nouvelle version";
        break;
      default:
        label = null;
        break;
    }
    return {
      label: label,
      key,
      icon: <AiOutlineAppstoreAdd style={{ fontSize: "1.3rem" }} />,
      style: {
        color: "#7129ac",
        textAlign: "center",
        fontWeight: "bold",
      },
    };
  };

  const getMenu = () => {
    return (
      <div>
        <Search
          flows={fetchState.flows}
          filterFlows={setFilteredFlows}
          focusedItem={focusedItem}
          filteredFlows={filteredFlows}
        />
        <Menu
          items={[
            getNew("brand", "new-brand"),
            ...filteredFlows.map((brandFlows, i) => {
              return {
                key: brandFlows._id,
                label: brandFlows._id,
                style: {
                  width: "200px",
                },
                children: [
                  {
                    ...getNew("flow", `${brandFlows._id}-new-flow`),
                    key: i,
                  },
                  ...Object.keys(brandFlows.transformed_flows).map(
                    (flowName, j) => {
                      return {
                        key: `${i}-${j}`,
                        label: flowName,
                        style: {
                          width: "200px",
                        },
                        children: [
                          getNew("version", `${flowName}-${i}-${j}`),
                          ...brandFlows.transformed_flows[flowName].map(
                            (flow, k) => {
                              return {
                                key: `${i}-${j}-${flow._id}`,
                                label: flow.version,
                                style: {
                                  width: "200px",
                                },
                              };
                            }
                          ),
                        ],
                      };
                    }
                  ),
                ],
              };
            }),
          ]}
          onClick={handleFlowSelectChange}
          onSelect={(keys) => console.log("on select", keys)}
          onOpenChange={(openKeys) => setFocusedItem(openKeys)}
        />
      </div>
    );
  };

  const handleNewFlowCreation = function (newFlow) {
    const { app } = params;
    console.log(newFlow);
    navigate(`../${app}/${newFlow.brand}/${newFlow.name}/${newFlow.version}`, {
      replace: true,
    });

    if (newFlow.template) {
      if (newFlow.template === "feedbacksTemplate") {
        newFlow = feedbacksTemplate(
          newFlow.brand,
          newFlow.name,
          newFlow.version,
          newFlow.displayName,
          newFlow.color,
          newFlow.logo_link
        );
      }
    }

    flowDispatcher({
      type: "clear-flow",
    });

    flowDispatcher({
      type: "update-flow",
      flow: {
        ...newFlow,
        app,
      },
    });
    fetchDispatcher({
      type: "update-flow-status",
      isPublished: false,
    });

    setNewFormVisible(false);
    setNewElementName("");
    setNewFlowBrand("");
    setNewFlowName("");
  };

  const handleCloseNewFlowForm = function () {
    setNewFormVisible(false);
    setNewElementName("");
    setNewFlowBrand("");
    setNewFlowName("");
  };

  return (
    <div className={styles.button_container}>
      {newFormVisible && (
        <NewFlowForm
          elementName={newElementName}
          brand={newFlowBrand}
          flowName={newFlowName}
          onValidate={handleNewFlowCreation}
          close={handleCloseNewFlowForm}
        />
      )}

      <Spinner
        spinning={fetchState.loadingFlowListApi}
        style={{
          paddingBottom: "10px",
          marginLeft: ".5rem",
          marginRight: ".5rem",
        }}
      />

      {!fetchState.loadingFlowListApi && (
        <Dropdown overlay={getMenu}>
          <span className={`${styles.icon_container} ${styles.disabled_hover}`}>
            <IoIosList className={styles.flow_list_button} />
          </span>
        </Dropdown>
      )}
    </div>
  );
};

export default FlowList;
